import { render, staticRenderFns } from "./PlayerBadge.vue?vue&type=template&id=bcf26ab6&"
import script from "./PlayerBadge.vue?vue&type=script&lang=js&"
export * from "./PlayerBadge.vue?vue&type=script&lang=js&"
import style0 from "./PlayerBadge.vue?vue&type=style&index=0&id=bcf26ab6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports